import { render, staticRenderFns } from "./IR_groups.vue?vue&type=template&id=3d52c06e"
import script from "./IR_groups.vue?vue&type=script&lang=js"
export * from "./IR_groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports